document.addEventListener('DOMContentLoaded', () => {
  const textareas = document.querySelectorAll(
    '[data-textarea-wrapper] [data-textarea-field]',
  )

  textareas &&
    textareas.forEach((textarea) => {
      textarea.addEventListener('input', onInput)
    })

  function onInput(event) {
    event.target.value = event.target.value.substr(0, 1000)
    const length = event.target.value.length
    const counter = event.target.nextElementSibling.querySelector(
      '[data-textarea-counter]',
    )
    counter.textContent = length
  }
})
